import { IconButton, styled } from '@chronosphereio/chrono-ui';
// This is a temporary override for an old use case until we complete the Chrono UI Popover backfill (sc-138310)
// eslint-disable-next-line no-restricted-imports
import { Popover } from '@mui/material';
import { Circle as CircleIcon } from 'mdi-material-ui';
import React from 'react';
import { ColorPicker } from '@/components/ColorPicker';
import { useChartsTheme } from '../../../components/context/ChartsProvider';
import { ThresholdInputProps } from './ThresholdInput';

export function ThresholdColorPicker({
  color,
  onColorChange,
  label,
  customPalette,
}: Pick<ThresholdInputProps, 'color' | 'onColorChange' | 'label'> & { customPalette?: string[] }) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const openColorPicker = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeColorPicker = () => {
    setAnchorEl(null);
  };

  const {
    thresholds: { defaultColor, palette },
  } = useChartsTheme();

  return (
    <>
      <ColorIconButton
        aria-label={`change threshold ${label} color`}
        isSelected={isOpen}
        iconColor={color}
        onClick={openColorPicker}
      >
        <CircleIcon />
      </ColorIconButton>
      <Popover
        data-testid="threshold color picker"
        open={isOpen}
        anchorEl={anchorEl}
        onClose={closeColorPicker}
        PaperProps={{ sx: { padding: (theme) => theme.spacing(2) } }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <ColorPicker color={color} onChange={onColorChange} palette={customPalette || [defaultColor, ...palette]} />
      </Popover>
    </>
  );
}

const ColorIconButton = styled(IconButton, {
  shouldForwardProp: (props) => props !== 'isSelected' && props !== 'iconColor',
})<{
  iconColor?: string;
  isSelected?: boolean;
}>(({ iconColor, isSelected }) => ({
  backgroundColor: isSelected && iconColor ? `${iconColor}3F` : 'undefined', // 3F represents 25% opacity
  color: iconColor,
}));
